import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput ,MDBDataTable  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'
import LoadingOverlay from 'react-loading-overlay';


export default class Modalshowworkgraphic extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  loading:false,





   name_workorder:'',

   code:'',
   id_workorder:'',
   name_worklist:'',
   num_worklist:'',
   price_worklist:'',
   description_worklist:'',
   material_worklist:'',
   materialvinyl_worklist:'',
   papertype_worklist:'',
   statecut_worklist:'',
   status_worklist:'1',

   worklistdata:[],
   workshow:[],
   datesentgf_workorder:'',//วันที่ส่งมา
   material_workorder:'',//ประเภทวัสดุ
   materialvinyl_workorder:'',//การติดตั้ง
   papertype_workorder:'',//ประเภทกระดาษ
   description_workorder:'',//คำอธิบาย

   deposit_workorder:'',//มัดจำ
   price_workorder:'',//ราคาเต็ม
   remain_workorder:'',//คงเหลือ
   namecustomer_workorder:'',
   example_workorder:'',
}

//this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
//this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.handleChange4 = this.handleChange4.bind(this);
this.handleChangefile = this.handleChangefile.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.onChangetype = this.onChangetype.bind(this);
this.onClick = this.onClick.bind(this);
this.onClickmaterialvinyl = this.onClickmaterialvinyl.bind(this);
this.onClickpapertype = this.onClickpapertype.bind(this);
this.onClickstatecut = this.onClickstatecut.bind(this);
this.getworklist = this.getworklist.bind(this);
this.getworkshow = this.getworkshow.bind(this);


}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.setState({ id_workorder:this.props.id_workorder})
  
 this.getworklist();
 this.getworkshow();
}

handleChangefile(event) {    this.setState({example_workorder: event.target.files[0]});  }

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

onChangetype(value) {
  this.setState({ paymentstatus_workorder:value})
}

onClick = (nr) => () => {
  this.setState({
    material_worklist: nr,
  });
};

onClickmaterialvinyl = (nr) => () => {
  this.setState({
    materialvinyl_worklist: nr,
  });
};

onClickpapertype = (nr) => () => {
  this.setState({
    papertype_worklist: nr,
  });
};

onClickstatecut = (nr) => () => {
  this.setState({
    statecut_worklist: nr,
  });
};

getworklist (){
  
    const {id_workorder} = this.state.id_workorder
    api.get('selectworklistshow.php?id_workorder='+this.props.id_workorder)
    .then(res => {
    //  console.log(res);
      this.setState({ worklistdata: res.data })
    //  this.setState({ NAME: res.data[0].NAME})
    //  this.setState({ PNAME: res.data[0].PNAME})
     // this.setState({ FACULTY: res.data[0].FACULTY})
    }) 
}

getworkshow (){
  this.setState({ loading: true })
    const {id_workorder} = this.state.id_workorder
    api.get('selectworkedit.php?id_workorder='+this.props.id_workorder)
    .then(res => {
    //  console.log(res);
      this.setState({ workshow: res.data, loading: false })
      this.setState({ datesentgf_workorder: res.data[0].datesentgf_workorder})
      this.setState({ description_workorder: res.data[0].description_workorder})
      this.setState({ deposit_workorder: res.data[0].deposit_workorder})
      this.setState({ price_workorder: res.data[0].price_workorder})
      this.setState({ remain_workorder: res.data[0].remain_workorder})
      this.setState({ namecustomer_workorder: res.data[0].namecustomer_workorder})
      this.setState({ example_workorder: res.data[0].example_workorder})
      this.setState({ loading: false })
    }) 
}





 componentDidMount() {
     // const { code } = this.props.code
   //   console.log(id_send);
     this.setState({ code:this.props.code})
     this.setState({ name_workorder:this.props.name_workorder})
     this.setState({ id_workorder:this.props.id_workorder})
    
     

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


 // handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
 // handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
 // handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit(e) {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("code_workorderlist", this.state.code);
      datafrm.append("id_workorderlist", this.state.id_workorder);
      datafrm.append("name_worklist", this.state.name_worklist);
      datafrm.append("num_worklist", this.state.num_worklist);
      datafrm.append("price_worklist", this.state.price_worklist);
      datafrm.append("description_worklist", this.state.description_worklist);
      datafrm.append("material_worklist", this.state.material_worklist);
      datafrm.append("materialvinyl_worklist", this.state.materialvinyl_worklist);
      datafrm.append("papertype_worklist", this.state.papertype_worklist);
      datafrm.append("statecut_worklist", this.state.statecut_worklist);
      datafrm.append("status_worklist", this.state.status_worklist);
      

    
      
      api.post("insertworklist.php",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })

   .then(res => {
  
    if (res.status=== 200) {
        Swal.fire({
            title: 'บันทึกรายการสำเร็จ',
            icon: 'success',
          // showCancelButton: true,
            confirmButtonText: 'ตกลง',
          // cancelButtonText: 'No, keep it'
          }).then((result) => {
          //  this.toggle();  
          this.getworklist();
            
          })
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })


//อัพเดทสถานะ
  // Axios
  // // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  //   .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
  //   .then(res => {
  //     console.log("response: ", res)
 
  //     if (res.data.length !== 0) {
  //      // this.showitem = true;
  //       console.log(res)
  //       console.log(res.data.length)
  //    }else{
  //     // window.location.href = '/'
  //    }
  //    this.toggle()
  //  })
  // this.toggle()


}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 


  }




 

  

    render() {

console.log(this.state.code)
console.log(this.state.id_workorder)
console.log(this.state.name_worklist)
console.log(this.state.num_worklist)
console.log(this.state.price_worklist)
console.log(this.state.description_worklist)
console.log(this.state.material_worklist)
console.log(this.state.materialvinyl_worklist)
console.log(this.state.papertype_worklist)
console.log(this.state.statecut_worklist)
console.log(this.state.status_worklist)



const data = {
    columns: [
      {
        label: 'ลำดับ',
        field: 'list',
        sort: 'list',
        width: 150
      },
      {
        label: 'รายการ',
        field: 'OLDID',
        sort: 'OLDID',
        width: 270
      },
      {
        label: 'จำนวน',
        field: 'NAME',
        sort: 'NAME',
        width: 200
      },
      {
        label: 'อุปกรณ์',
        field: 'equipment',
        sort: 'equipment',
        width: 200
      },
       {
        label: 'ราคา',
        field: 'DATES',
        sort: 'DATES',
        width: 200
      },
      {
        label: 'วันที่เพิ่ม',
        field: 'FACULTY',
        sort: 'FACULTY',
        width: 100
      }

    ],

    rows: [...this.state.worklistdata.map((data, i) => (
      {
         list: <>{i+1}</>,
         OLDID: <>{data.name_worklist}</>,
         NAME: <>{data.num_worklist}</>,
         equipment: <><p>วัสดุ : {data.material_worklist}</p> <p>การติดตั้ง : {data.materialvinyl_worklist}</p> <p>ประเภท : {data.papertype_worklist} </p><p>การตัด : {data.statecut_worklist} </p></>,
         DATES: <>{data.price_worklist}</>,
         FACULTY: <>{data.dateadd_worklist}</>,
        

        //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

      }
     ))] 

};


const persons = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={20}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>



//console.log("1".padStart(5, "0"));
        return (
            <>
            <MDBBtn onClick={this.toggle} color="unique" size="sm"><MDBIcon far icon="plus-square" /> แสดงรายการ</MDBBtn>

            
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
                 
              <MDBModalHeader toggle={this.toggle} className="text-center"><MDBIcon icon="align-left" /> รายการใบสั่งงาน </MDBModalHeader><br/>
              {/* <div className="text-center"><h4>ร้านลูกแม่น้ำปิงไวนิล 055-023245, 092-5583982, 0827730380</h4></div> */}
                <LoadingOverlay
                  active={this.state.loading}
                  spinner
                  text='Loading your data...'
                  >
            
              <MDBModalBody className="text-left">
              <div>
              
              <MDBRow>
                    <MDBCol md="6">
                        <MDBAlert color="success" >
                            <h5 className="text-left"> รหัสใบสั่งงาน : {this.state.code}</h5>   
                            <h5 className="text-left"> ชื่อใบสั่งงาน : {this.state.name_workorder}</h5>
                            <h5 className="text-left"> คำอธิบาย : {this.state.description_workorder}</h5>
                        </MDBAlert>
                    </MDBCol>
                    <MDBCol md="6">
                    <MDBAlert color="success" >
                            <h5 className="text-left"> ส่งถึงเมื่อ : {this.state.datesentgf_workorder}</h5>   
                            <h5 className="text-left"> ชื่อลูกค้า : {this.state.namecustomer_workorder}</h5>
                            {/* <h5 className="text-left"> ราคา : {this.state.price_workorder}</h5>
                            <h5 className="text-left"> มัดจำ : {this.state.deposit_workorder}</h5>
                            <h5 className="text-left"> คงเหลือ : {this.state.remain_workorder}</h5> */}
                        </MDBAlert>
                    </MDBCol>
                
                </MDBRow>
                <MDBRow>
                    
                    {this.state.example_workorder !=='' && this.state.example_workorder !== null   ?<>
                    <MDBCol>
                    <div className='text-center'>
                    <p>ตัวอย่างจากลูกค้า.</p>
                    <img src={`https://lookmaenamping.com/sorlalumbackend/uploads/${this.state.example_workorder}`} alt="thumbnails" className="img-thumbnail " />
                    </div> 
                    </MDBCol>
                        </>:<> <MDBCol>
                        <p>ตัวอย่างจากลูกค้า</p>
                        -- ไม่มีตัวอย่างจากลูกค้า --   
                        </MDBCol></>}
                        
                </MDBRow>
                 
              </div>
              <hr/>
              {persons}


              </MDBModalBody>
              </LoadingOverlay>  
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
              
            </MDBModal>
          </>
          
        )
    }
}
